import { FunctionComponent, lazy, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'

const Preference = lazy(
  () => import('@/modules/Attendance/submodules/Scheduled/pages/Preference'),
)
const SpecialitiesSearch = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/Scheduled/pages/SpecialitiesSearch'
    ),
)
const MedicSearch = lazy(
  () => import('@/modules/Attendance/submodules/Scheduled/pages/MedicSearch'),
)
const MedicProfile = lazy(
  () => import('@/modules/Attendance/submodules/Scheduled/pages/MedicProfile'),
)
const PsychologistProfile = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsychologistProfile'
    ),
)
const NewPsychologistProfile = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/NewPsychologistProfile'
    ),
)
const Attachments = lazy(
  () => import('@/modules/Attendance/submodules/Scheduled/pages/Attachments'),
)

const WaitingRoom = lazy(
  () => import('@/modules/Attendance/submodules/Scheduled/pages/WaitingRoom'),
)

const ScreeningPsychologist = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/ScreeningPsychologist'
    ),
)
const SpeacialityWithTimeSlot = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/Scheduled/pages/SpecialityWithTimeSlot'
    ),
)
const TimeSlotPage = lazy(
  () => import('@/modules/Attendance/submodules/Scheduled/pages/TimeSlotPage'),
)
const ProfessionalSearch = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/Scheduled/pages/ProfessionalSearch/ProfessionalSearch.component'
    ),
)

const routes = [
  <Route
    path="/atendimento-agendado/preferencia/:council"
    key="/atendimento-agendado/preferencia"
    exact
    component={Preference}
  />,
  <Route
    path="/atendimento-agendado/especialidades"
    key="/atendimento-agendado/especialidades"
    component={SpecialitiesSearch}
  />,
  <Route
    path="/atendimento-agendado/preferencia/:council/especialidades"
    key="/atendimento-agendado/especialidades"
    component={SpecialitiesSearch}
  />,
  <Route
    path="/atendimento-agendado/preferencia/:council/especialidades/?filtrar=encaixe"
    key="/atendimento-agendado/especialidades"
    component={SpecialitiesSearch}
  />,
  <Route
    path="/atendimento-agendado/preferencia/busca-profissional/:council"
    key="/atendimento-agendado/busca-profissional"
    exact
    component={MedicSearch}
  />,
  <Route
    path="/atendimento-agendado/preferencia/busca-profissional/:council/:speciality"
    key="/atendimento-agendado/especialidades/busca-profissional/especialidade"
    exact
    component={MedicSearch}
  />,
  <Route
    path="/atendimento-agendado/especialidade/busca/:professionalType/:speciality?"
    key="/atendimento-agendado/especialidade/busca"
    exact
    component={SpeacialityWithTimeSlot}
  />,
  <Route
    path="/atendimento-agendado/especialidade/encaixe/:professionalType/:speciality?"
    key="/atendimento-agendado/especialidade/encaixe"
    exact
    component={TimeSlotPage}
  />,
  <Route
    path="/atendimento-agendado/categoria/psicologoViva/:medicId"
    key="/atendimento-agendado/categoria/psicologoViva/:medicId"
    exact
    component={PsychologistProfile}
  />,
  <Route
    path="/atendimento-agendado/categoria/psicologoViva/:medicId/:token"
    key="/atendimento-agendado/psicologoViva/reagendamento"
    exact
    component={PsychologistProfile}
  />,

  <Route
    path="/atendimento-agendado/categoria/psicologos/:medicId"
    key="/atendimento-agendado/categoria/psicologos/:medicId"
    exact
    component={NewPsychologistProfile}
  />,
  <Route
    path="/atendimento-agendado/categoria/psicologos/:medicId/:token"
    key="/atendimento-agendado/psicologos/reagendamento"
    exact
    component={NewPsychologistProfile}
  />,

  <Route
    path="/atendimento-agendado/categoria/:council/:medicId"
    key="/atendimento-agendado/medico"
    exact
    component={MedicProfile}
  />,
  <Route
    path="/atendimento-agendado/categoria/:council/:medicId/:token"
    key="/atendimento-agendado/medico/reagendamento"
    exact
    component={MedicProfile}
  />,
  <Route
    path="/atendimento-agendado/anexos"
    key="/atendimento-agendado/anexos"
    exact
    component={Attachments}
  />,
  <Route
    path="/atendimento-agendado/sala-de-espera/:id"
    key="/atendimento-agendado/sala-de-espera/:id"
    exact
    component={WaitingRoom}
  />,
  <Route
    path="/atendimento-agendado/triagem-psicologo/busca-profissional"
    key="/atendimento-agendado/triagem-psicologo/busca-profissional"
    exact
    component={ScreeningPsychologist}
  />,
  <Route
    path="/atendimento-agendado/busca-profissional-agenda"
    key="/atendimento-agendado/busca-profissional-agenda"
    exact
    component={ProfessionalSearch}
  />,
]

const ScheduledRoutes: FunctionComponent = () => (
  <Fragment>
    <Switch>{routes}</Switch>
  </Fragment>
)

export default ScheduledRoutes
